module.exports = __webpack_public_path__ + "assets/8d8adc721fafa2612051eb90d1bd807e.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-BookItalic.woff
 ** module id = 1735
 ** module chunks = 1
 **/